import { FETCH_ACTIVITY_LOG } from "../actions/actionTypes";
import { updateActionErrors } from "./updateErrors";
import { getActivityLogs } from "../../api/graphql/queries/activityLog";
import graphqlClient from "../../api/axios_interceptor";

export const parseLogs = (log) => ({
    logId: log.id,
    username: log.actorUsername,
    fullname: log.actorFullname,
    shortDescription: log.shortDescription,
    longDescription: log.longDescription,
    activityTs: new Date(log.activityTs)

})
const fetchActivityLogsMiddleware = async (action) => {
    try{
        let activityLogs = {};
        const payload = action.payload;
        const query = getActivityLogs(payload.teamMemberIds, payload.startDate, payload.endDate);
        await graphqlClient({
            data: {query}
        }).then( (queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
                const logs = queryResult.data.data.activityLogs.logs.map(parseLogs);
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        logs,
                        offset: queryResult.data.data.activityLogs.next
                    }
                })
            }
        })

    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}


export const activityLogMiddleware =  storeAPI => next => async action => {
    switch (action.type) {
        case FETCH_ACTIVITY_LOG:
            action = await fetchActivityLogsMiddleware(action);
            break;
    }
    return next(action);
}